import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Flag } from "lucide-react";
import SectionHead from "../SectionHead";
import { Reveal } from "../motion";

function TeamCard({ m, index }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const bio = m.bio || t("home.team.bio_placeholder");
  const long = bio.length > 140;

  return (
    <div className="gxr-card group p-6 h-full flex flex-col items-center text-center" data-testid={`home-team-${index + 1}`}>
      <div className="relative">
        <div className="h-24 w-24 rounded-full bg-gradient-to-br from-sand to-ivory border-2 border-gold/40 flex items-center justify-center font-display text-3xl text-forest transition-transform duration-500 group-hover:scale-105 overflow-hidden">
          {m.photo ? <img src={m.photo} alt={m.name} className="h-full w-full object-cover" /> : (m.name && !/^Team Member|^عضو الفريق/.test(m.name) ? m.name.replace(/^(Dr\.|د\.)\s*/, "").split(" ").slice(0, 2).map((w) => w[0]).join("") : String(index + 1).padStart(2, "0"))}
        </div>
        <span
          className="absolute -bottom-1 ltr:-right-1 rtl:-left-1 h-8 w-8 rounded-full bg-white border-2 border-white shadow-md flex items-center justify-center overflow-hidden"
          title={m.country || ""}
          data-testid={`home-team-flag-${index + 1}`}
        >
          {m.flag ? <img src={m.flag} alt={m.country || "flag"} className="h-full w-full object-cover" /> : <Flag className="h-3.5 w-3.5 text-gold" />}
        </span>
      </div>
      <h3 className="font-display text-lg text-ink mt-5 leading-tight">{m.name}</h3>
      <div className="mt-1 text-[11px] font-bold uppercase tracking-[0.14em] text-gold">{m.role}</div>
      {m.country && <div className="mt-1 text-[11px] text-slate">{m.country}</div>}
      <p className={`mt-3 text-xs text-slate leading-relaxed whitespace-pre-line ${open ? "" : "line-clamp-4"}`}>{bio}</p>
      {long && (
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid={`home-team-toggle-${index + 1}`}
          className="mt-auto pt-3 text-[11px] font-bold text-forest gxr-link"
        >
          {open ? t("home.team.read_less") : t("home.team.read_more")}
        </button>
      )}
    </div>
  );
}

export default function Team() {
  const { t } = useTranslation();
  const members = t("home.team.members", { returnObjects: true });

  return (
    <section className="surface-2 py-20 lg:py-28 border-y border-line" data-testid="home-team">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12">
        <SectionHead kicker={t("home.team.kicker")} title={t("home.team.title")} to="/professionals" linkLabel={t("home.team.cta")} />
        <Reveal><p className="mt-4 text-slate max-w-2xl">{t("home.team.body")}</p></Reveal>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {Array.isArray(members) && members.map((m, i) => (
            <Reveal key={i} delay={(i % 5) * 0.08}>
              <TeamCard m={m} index={i} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
